import { render, staticRenderFns } from "./FloatingDownload.vue?vue&type=template&id=6ffa1025&scoped=true"
import script from "./FloatingDownload.vue?vue&type=script&lang=js"
export * from "./FloatingDownload.vue?vue&type=script&lang=js"
import style0 from "./style.scss?vue&type=style&index=0&id=6ffa1025&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ffa1025",
  null
  
)

export default component.exports